import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './GeoLayout.css';

function GeoLayout({ onLogout }) {
  return (
    <div className="geo-layout">
      <nav className="geo-sidebar">
        <div className="sidebar-header">
          <h3>SP MerchFlow</h3>
          <p className="geo-subtitle">Géolocalisation</p>
        </div>
        <ul>
          <li><NavLink to="/geo/geolocalisation">Carte des clients</NavLink></li>
        </ul>
        <button onClick={onLogout} className="sidebar-logout-button">Déconnexion</button>
      </nav>
      <main className="geo-content">
        <Outlet />
      </main>
    </div>
  );
}

export default GeoLayout;
